<template>
  <div class="profil-container">
    <h3 class="profil-title">Halaman Pengisian Data Vendor</h3>
    <p class="profil-subtitle">Silahkan mengisi data sesuai kolom di bawah</p>
    <!-- 1 -->
    <block-label :label="'I. IMPLEMENTASI'" />
    <input-form-penilaian-kplh
      :tables="tableInput.inputForm1"
      :listInput="listInput.inputForm1"
      :modelName="'addedIUJP'"
      :isRequired="false"
      :mutationName="'kplhStore/SET_KPLH_FORM'"
      :storeName="'kplhStore'"
      :modalName="'modal_add_iujp'"
      :disabled="is_hse_validation || is_preview"
    />

    <input-form-penilaian-kplh
      :tables="tableInput.inputForm2"
      :listInput="listInput.inputForm2"
      :modelName="'addedIUJP'"
      :isRequired="false"
      :mutationName="'kplhStore/SET_KPLH_FORM'"
      :storeName="'kplhStore'"
      :modalName="'modal_add_iujp'"
      :disabled="is_hse_validation || is_preview"
    />

    <block-label :label="'I.3 PENGELOLAAN KESEHATAN KERJA'" />
    <input-form-penilaian-kplh
      :tables="tableInput.inputForm3"
      :listInput="listInput.inputForm3"
      :modelName="'addedIUJP'"
      :isRequired="false"
      :mutationName="'kplhStore/SET_KPLH_FORM'"
      :storeName="'kplhStore'"
      :modalName="'modal_add_iujp'"
      :disabled="is_hse_validation || is_preview"
    />

    <input-form-penilaian-kplh
      :tables="tableInput.inputForm4"
      :listInput="listInput.inputForm4"
      :modelName="'addedIUJP'"
      :isRequired="false"
      :mutationName="'kplhStore/SET_KPLH_FORM'"
      :storeName="'kplhStore'"
      :modalName="'modal_add_iujp'"
      :disabled="is_hse_validation || is_preview"
    />

    <input-form-penilaian-kplh
      :tables="tableInput.inputForm5"
      :listInput="listInput.inputForm5"
      :modelName="'addedIUJP'"
      :isRequired="false"
      :mutationName="'kplhStore/SET_KPLH_FORM'"
      :storeName="'kplhStore'"
      :modalName="'modal_add_iujp'"
      :disabled="is_hse_validation || is_preview"
    />

    <input-form-penilaian-kplh
      :tables="tableInput.inputForm6"
      :listInput="listInput.inputForm6"
      :modelName="'addedIUJP'"
      :isRequired="false"
      :mutationName="'kplhStore/SET_KPLH_FORM'"
      :storeName="'kplhStore'"
      :modalName="'modal_add_iujp'"
      :disabled="is_hse_validation || is_preview"
    />

    <input-form-penilaian-kplh
      :tables="tableInput.inputForm7"
      :listInput="listInput.inputForm7"
      :modelName="'addedIUJP'"
      :isRequired="false"
      :mutationName="'kplhStore/SET_KPLH_FORM'"
      :storeName="'kplhStore'"
      :modalName="'modal_add_iujp'"
      :disabled="is_hse_validation || is_preview"
    />

    <div class="profil-btn-wrapper">
      <div @click="goBack()" class="btn-landing">Kembali</div>
      <div @click="goNext()" href="" class="btn-landing">
        Simpan dan Lanjutkan
      </div>
    </div>
  </div>
</template>

<script>
import InputArea from '../../components/forms/input/input-area.vue'
import BlockLabel from '../../components/forms/label/blockLabel.vue'
import PlainLabel from '../../components/forms/label/plainLabel.vue'
import UploadFile from '../../components/forms/input/multiple_upload.vue'
import InputFormPenilaianKplh from '../../components/forms/input-form-penilaian-kplh.vue'
import DescPenilaian from '../../components/desc-penilaian.vue'
export default {
  components: {
    BlockLabel,
    PlainLabel,
    InputArea,
    UploadFile,
    InputFormPenilaianKplh,
    DescPenilaian,
  },
  data() {
    return {
      tableInput: {
        inputForm1: [
          {
            name: 'I.1 KAMPANYE',
            obj_name: 'jenis',
            css: 'column30 mr10 col-nohover',
            input: false,
            type: 'name',
          },
          {
            name: 'Tingkat Risiko',
            obj_name: 'jenis',
            css: 'column15 mr10',
            input: false,
            type: 'subname',
          },
          {
            name: 'Attachment',
            obj_name: 'attachment',
            css: 'column15 mr10',
            input: true,
            type: 'file',
          },
          {
            name: 'Bobot',
            obj_name: 'bobot',
            css: 'column10',
            input: false,
            type: 'bobot',
          },
          {
            name: 'Nilai',
            obj_name: 'value',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'Catatan Penilai',
            obj_name: 'note',
            css: 'column20',
            input: true,
            type: 'text',
          },
          {
            name: 'Catatan Head HSE',
            obj_name: 'internal_note',
            css: 'column20',
            input: true,
            type: 'internal',
          },
        ],
        inputForm2: [
          {
            name: 'I.2 INSPEKSI',
            obj_name: 'jenis',
            css: 'column30 mr10 col-nohover',
            input: false,
            type: 'name',
          },
          {
            name: 'Tingkat Risiko',
            obj_name: 'jenis',
            css: 'column15 mr10',
            input: false,
            type: 'subname',
          },
          {
            name: 'Attachment',
            obj_name: 'attachment',
            css: 'column15 mr10',
            input: true,
            type: 'file',
          },
          {
            name: 'Bobot',
            obj_name: 'bobot',
            css: 'column10',
            input: false,
            type: 'bobot',
          },
          {
            name: 'Nilai',
            obj_name: 'value',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'Catatan Penilai',
            obj_name: 'note',
            css: 'column20',
            input: true,
            type: 'text',
          },
          {
            name: 'Catatan Head HSE',
            obj_name: 'internal_note',
            css: 'column20',
            input: true,
            type: 'internal',
          },
        ],
        inputForm3: [
          {
            name: 'I.3.1 PEMERIKSAAN KESEHATAN',
            obj_name: 'jenis',
            css: 'column30 mr10 col-nohover',
            input: false,
            type: 'name',
          },
          {
            name: 'Tingkat Risiko',
            obj_name: 'jenis',
            css: 'column15 mr10',
            input: false,
            type: 'subname',
          },
          {
            name: 'Attachment',
            obj_name: 'attachment',
            css: 'column15 mr10',
            input: true,
            type: 'file',
          },
          {
            name: 'Bobot',
            obj_name: 'bobot',
            css: 'column10',
            input: false,
            type: 'bobot',
          },
          {
            name: 'Nilai',
            obj_name: 'value',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'Catatan Penilai',
            obj_name: 'note',
            css: 'column20',
            input: true,
            type: 'text',
          },
          {
            name: 'Catatan Head HSE',
            obj_name: 'internal_note',
            css: 'column20',
            input: true,
            type: 'internal',
          },
        ],
        inputForm4: [
          {
            name: 'I.3.2 PENGELOLAAN KELELAHAN',
            obj_name: 'jenis',
            css: 'column30 mr10 col-nohover',
            input: false,
            type: 'name',
          },
          {
            name: 'Tingkat Risiko',
            obj_name: 'jenis',
            css: 'column15 mr10',
            input: false,
            type: 'subname',
          },
          {
            name: 'Attachment',
            obj_name: 'attachment',
            css: 'column15 mr10',
            input: true,
            type: 'file',
          },
          {
            name: 'Bobot',
            obj_name: 'bobot',
            css: 'column10',
            input: false,
            type: 'bobot',
          },
          {
            name: 'Nilai',
            obj_name: 'value',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'Catatan Penilai',
            obj_name: 'note',
            css: 'column20',
            input: true,
            type: 'text',
          },
          {
            name: 'Catatan Head HSE',
            obj_name: 'internal_note',
            css: 'column20',
            input: true,
            type: 'internal',
          },
        ],
        inputForm5: [
          {
            name: 'I.3.3 PENGELOLAAN ERGONOMI',
            obj_name: 'jenis',
            css: 'column30 mr10 col-nohover',
            input: false,
            type: 'name',
          },
          {
            name: 'Tingkat Risiko',
            obj_name: 'jenis',
            css: 'column15 mr10',
            input: false,
            type: 'subname',
          },
          {
            name: 'Attachment',
            obj_name: 'attachment',
            css: 'column15 mr10',
            input: true,
            type: 'file',
          },
          {
            name: 'Bobot',
            obj_name: 'bobot',
            css: 'column10',
            input: false,
            type: 'bobot',
          },
          {
            name: 'Nilai',
            obj_name: 'value',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'Catatan Penilai',
            obj_name: 'note',
            css: 'column20',
            input: true,
            type: 'text',
          },
          {
            name: 'Catatan Head HSE',
            obj_name: 'internal_note',
            css: 'column20',
            input: true,
            type: 'internal',
          },
        ],
        inputForm6: [
          {
            name: 'I.3.4 PENGELOLAAN HIGIENE',
            obj_name: 'jenis',
            css: 'column30 mr10 col-nohover',
            input: false,
            type: 'name',
          },
          {
            name: 'Tingkat Risiko',
            obj_name: 'jenis',
            css: 'column15 mr10',
            input: false,
            type: 'subname',
          },
          {
            name: 'Attachment',
            obj_name: 'attachment',
            css: 'column15 mr10',
            input: true,
            type: 'file',
          },
          {
            name: 'Bobot',
            obj_name: 'bobot',
            css: 'column10',
            input: false,
            type: 'bobot',
          },
          {
            name: 'Nilai',
            obj_name: 'value',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'Catatan Penilai',
            obj_name: 'note',
            css: 'column20',
            input: true,
            type: 'text',
          },
          {
            name: 'Catatan Head HSE',
            obj_name: 'internal_note',
            css: 'column20',
            input: true,
            type: 'internal',
          },
        ],
        inputForm7: [
          {
            name: 'I.4 PENGELOLAAN LINGKUNGAN KERJA',
            obj_name: 'jenis',
            css: 'column30 mr10 col-nohover',
            input: false,
            type: 'name',
          },
          {
            name: 'Tingkat Risiko',
            obj_name: 'jenis',
            css: 'column15 mr10',
            input: false,
            type: 'subname',
          },
          {
            name: 'Attachment',
            obj_name: 'attachment',
            css: 'column15 mr10',
            input: true,
            type: 'file',
          },
          {
            name: 'Bobot',
            obj_name: 'bobot',
            css: 'column10',
            input: false,
            type: 'bobot',
          },
          {
            name: 'Nilai',
            obj_name: 'value',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'Catatan Penilai',
            obj_name: 'note',
            css: 'column20',
            input: true,
            type: 'text',
          },
          {
            name: 'Catatan Head HSE',
            obj_name: 'internal_note',
            css: 'column20',
            input: true,
            type: 'internal',
          },
        ],
      },
      listInput: {
        inputForm1: [
          {
            type: 'form',
            name: 'Lampirkan salinan program kampanye tahun terakhir',
            subname: 'Kritis',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i1_1',
            inputStore: 'note_i1_1',
            fileStore: 'attachment_i1_1',
            tooltipText:
              'Dalam program kampanye telah meliputi  periode & metode penyampaian serta tema kampanye',
            internalNoteStore: 'internal_note_i1_1',
          },
          {
            type: 'form',
            name: 'Lampirkan salinan hasil evaluasi keefektifan hasil kampanye',
            subname: 'Kritis',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i1_2',
            inputStore: 'note_i1_2',
            fileStore: 'attachment_i1_2',
            tooltipText:
              'kampanye terlaksana >90% dan terdapat evaluasi efektivitas (tingkat pemahaman / perubahan perilaku / perubahan performance) contohnya: summary evaluasi keefektifan kampanye',
            internalNoteStore: 'internal_note_i1_2',
          },
        ],
        inputForm2: [
          {
            type: 'form',
            name: 'Lampirkan prosedur terkait inspeksi',
            subname: 'Tinggi',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i2_1',
            inputStore: 'note_i2_1',
            fileStore: 'attachment_i2_1',
            tooltipText:
              'Prosedur telah mencakup: jenis inspeksi, formulir / checklist yang digunakan dan tindak lanjut hasil inspeksi',
            internalNoteStore: 'internal_note_i2_1',
          },
          {
            type: 'form',
            name: 'Lampirkan salinan program inspeksi tahun terakhir',
            subname: 'Sedang',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i2_2',
            inputStore: 'note_i2_2',
            fileStore: 'attachment_i2_2',
            tooltipText:
              'Program inspeksi meliputi: jenis, lokasi, periode, dan PIC',
            internalNoteStore: 'internal_note_i2_2',
          },
          {
            type: 'form',
            name:
              'Lampirkan bukti pelaksanaan dan tindak lanjut inspeksi (minimal 2) ',
            subname: 'Sedang',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i2_3',
            inputStore: 'note_i2_3',
            fileStore: 'attachment_i2_3',
            tooltipText:
              'Melampirkan minimal 2 bukti pelaksanaan inspeksi dan melampirkan bukti tindak lanjutnya',
            internalNoteStore: 'internal_note_i2_3',
          },
          {
            type: 'form',
            name: 'Lampirkan salinan evaluasi hasil kegiatan inspeksi',
            subname: 'Kritis',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i2_4',
            inputStore: 'note_i2_4',
            fileStore: 'attachment_i2_4',
            tooltipText:
              'inspeksi terlaksana >90% dan  terdapat status tindak lanjutnya',
            internalNoteStore: 'internal_note_i2_4',
          },
        ],
        inputForm3: [
          {
            type: 'form',
            name: 'Lampirkan salinan prosedur pengelolaan kesehatan kerja',
            subname: 'Tinggi',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i31_1',
            inputStore: 'note_i31_1',
            fileStore: 'attachment_i31_1',
            tooltipText:
              'Prosedur meliputi: Jenis pemeriksaan (awal, berkala, akhir, dan khusus), parameter pemeriksaan dan tindak lanjut hasil pemeriksaan',
            internalNoteStore: 'internal_note_i31_1',
          },
          {
            type: 'form',
            name:
              'Lampirkan rekap hasil pemeriksaan kesehatan awal dan pemeriksaan kesehatan berkala untuk satu pekerja lapangan',
            subname: 'Tinggi',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i31_2',
            inputStore: 'note_i31_2',
            fileStore: 'attachment_i31_2',
            tooltipText:
              'Melampirkan hasil pemeriksaan kesehatan awal dan pemeriksaan kesehatan berkala untuk orang yang sama serta parameter pemeriksaan tidak sesuai peraturan perundangan',
            internalNoteStore: 'internal_note_i31_2',
          },
          {
            type: 'form',
            name:
              'Lampirkan salinan komunikasi kepada pekerja tentang hasil pemeriksaan kesehatan',
            subname: 'Kritis',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i31_3',
            inputStore: 'note_i31_3',
            fileStore: 'attachment_i31_3',
            tooltipText:
              'Salinan komunikasi hasil MCU  (email, tanda terima, dll), bukti konsultasi dengan dokter yang ditunjuk perusahaan dan bukti pelaksanaan tindak lanjut hasil konsultasi',
            internalNoteStore: 'internal_note_i31_3',
          },
          {
            type: 'form',
            name:
              'Lampirkan program pengelolaan kesehatan kerja tahun terakhir',
            subname: 'Kritis',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i31_4',
            inputStore: 'note_i31_4',
            fileStore: 'attachment_i31_4',
            tooltipText:
              'Program meliputi preventif, promotif, kuratif dan rehabilitatif',
            internalNoteStore: 'internal_note_i31_4',
          },
        ],
        inputForm4: [
          {
            type: 'form',
            name:
              'Lampirkan program terkait pengelolaan kelelahan di tempat kerja tahun terakhir',
            subname: 'Tinggi',
            bobot: '4',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i32_1',
            inputStore: 'note_i32_1',
            fileStore: 'attachment_i32_1',
            tooltipText:
              'Program meliputi:<br>- Identifikasi & evaluasi faktor kelelahan <br>- pelatihan / sosialisasi pengelolaan fatigue, dan <br>- pengendalian faktor kelelahan',
            internalNoteStore: 'internal_note_i32_1',
          },
        ],
        inputForm5: [
          {
            type: 'form',
            name: 'Lampirkan prosedur pengelolaan ergonomi',
            subname: 'Kritis',
            bobot: '1',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i33_1',
            inputStore: 'note_i33_1',
            fileStore: 'attachment_i33_1',
            tooltipText:
              '"Prosedur memuat: <br>- Identifikasi & penilaian ergonomi<br>- standar SPIP sesuai ergonomi, dan<br>- pengendalian hasil penilaian ergonomi',
            internalNoteStore: 'internal_note_i33_1',
          },
          {
            type: 'form',
            name: 'Lampirkan salinan hasil inspeksi ergonomi',
            subname: 'Kritis',
            bobot: '1',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i33_2',
            inputStore: 'note_i33_2',
            fileStore: 'attachment_i33_2',
            tooltipText:
              'Hasil inspeksi meliputi metode identifikasi & penilaian ergonomi yang digunakan, temuannya, dan rencana tindak lanjut yang akan dilakukan',
            internalNoteStore: 'internal_note_i33_2',
          },
        ],
        inputForm6: [
          {
            type: 'form',
            name: 'Lampirkan prosedur pengelolaan higiene',
            subname: 'Tinggi',
            bobot: '1',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i34_1',
            inputStore: 'note_i34_1',
            fileStore: 'attachment_i34_1',
            tooltipText:
              'Prosedur meliputi: Standar fasilitas penunjang untuk tercapainya higienitas, pengelolaan sanitasi area kerja, dan higienitas pengelolaan makanan dan minuman',
            internalNoteStore: 'internal_note_i34_1',
          },
          {
            type: 'form',
            name:
              'Lampirkan kompetensi petugas higiene industri yang ditunjuk perusahaan',
            subname: 'Kritis',
            bobot: '1',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i34_2',
            inputStore: 'note_i34_2',
            fileStore: 'attachment_i34_2',
            tooltipText:
              'Kompetensi petugas higiene industri sesuai dan masih berlaku',
            internalNoteStore: 'internal_note_i34_2',
          },
          {
            type: 'form',
            name: 'Lampirkan program pengelolaan higiene tahun terakhir',
            subname: 'Tinggi',
            bobot: '1',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i34_3',
            inputStore: 'note_i34_3',
            fileStore: 'attachment_i34_3',
            tooltipText:
              'Program meliputi: Pengelolaan sanitasi seluruh area kerja (pengelolaan tempat sampah, toilet, wastafel, kebersihan lantai & bangunan, kamar mandi dsb), higienitas pengelolaan makanan dan minuman',
            internalNoteStore: 'internal_note_i34_3',
          },
        ],
        inputForm7: [
          {
            type: 'form',
            name: 'Lampirkan prosedur terkait pengelolaan lingkungan kerja',
            subname: 'Tinggi',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i4_1',
            inputStore: 'note_i4_1',
            fileStore: 'attachment_i4_1',
            tooltipText:
              'Prosedur meliputi: Antisipasi, pengenalan, penilaian dan pengendalian semua bahaya lingkungan kerja sesuai bidang pekerjaan yang diajukan',
            internalNoteStore: 'internal_note_i4_1',
          },
          {
            type: 'form',
            name:
              'Lampirkan salinan salah satu analisa risiko terkait lingkungan kerja',
            subname: 'Tinggi',
            bobot: '2',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i4_2',
            inputStore: 'note_i4_2',
            fileStore: 'attachment_i4_2',
            tooltipText:
              'Analisa risiko meliputi: Identifikasi sumber, penilaian risiko, penetapan pengendalian',
            internalNoteStore: 'internal_note_i4_2',
          },
          {
            type: 'form',
            name:
              'Lampirkan salinan program pengelolaan lingkungan kerja yang terakhir',
            subname: 'Tinggi',
            bobot: '1',
            options: ['N/A', '0', '1', '2', '3'],
            optionStore: 'value_i4_3',
            inputStore: 'note_i4_3',
            fileStore: 'attachment_i4_3',
            tooltipText:
              'Program meliputi: Antisipasi, pengenalan, penilaian dan pengendalian semua bahaya lingkungan kerja sesuai bidang pekerjaan yang diajukan',
            internalNoteStore: 'internal_note_i4_3',
          },
        ],
      },
    }
  },
  computed: {
    is_hse_validation() {
      return this.$store.state.kplhStore.is_hse_validation
    },
    is_preview() {
      return this.$store.state.kplhStore.is_preview
    },
  },
  methods: {
    goBack() {
      this.$store.commit('kplhStore/SET_ACTIVE_PAGE', { name: 'grupah' })
    },
    goNext() {
      if (this.is_preview) {
        this.$store.commit('kplhStore/SET_ACTIVE_PAGE', { name: 'grupi2' })
      } else {
        this.$store.commit('kplhStore/SUBMIT_PENILAIAN_FOR_DRAFT', {
          onSuccess: () => {
            this.$store.commit('kplhStore/SET_ACTIVE_PAGE', { name: 'grupi2' })
          },
        })
      }
    },
  },
}
</script>
<style scoped>
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: block;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.modal-body {
  display: flex;
  flex-direction: column;
}

.modal-input-checkbox {
  margin-right: 20px;
}
</style>
